@if (corporateTaxEntity$ | async) {
  <form [formGroup]="identificatieFg">
    <snelstart-ui-text-form-control class="custom-input-250"
                                    [disabledControl]="true"
                                    formControlName="naamLichaam"
                                    id="naamLichaam"
                                    label="Naam belastingplichtige"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-bsn-form-control [disabledControl]="true"
                                   class="custom-input-250"
                                   formControlName="fiscaalNummer"
                                   id="fiscaalNummer"
                                   label="RSIN/fiscaal nummer"
    >
    </snelstart-ui-bsn-form-control>
  </form>

  <form [formGroup]="boekjaarFg">
    <snelstart-ui-date-form-control class="custom-input-250"
                                    formControlName="begindatum"
                                    id="begindatum"
                                    label="Begindatum boekjaar"
                                    placeholder="dd-mm-jjjj"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-date-form-control class="custom-input-250"
                                    formControlName="einddatum"
                                    id="einddatum"
                                    label="Einddatum boekjaar"
                                    placeholder="dd-mm-jjjj"
    >
    </snelstart-ui-date-form-control>
  </form>

  <form [formGroup]="identificatieFg">
    <snelstart-ui-select-form-control [disabledControl]="true"
                                      [options]="optionsJaNee"
                                      class="custom-input-250"
                                      formControlName="aangifteFiscaleEenheid"
                                      id="aangifteFiscaleEenheid"
                                      label="Betreft aangifte fiscale eenheid"
    >
    </snelstart-ui-select-form-control>
    <snelstart-ui-text-form-control class="custom-input-250"
                                    formControlName="achternaamOndertekenaar"
                                    id="achternaamOndertekenaar"
                                    label="Naam ondertekenaar"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control class="custom-input-250"
                                    formControlName="telefoonnummerOndertekenaar"
                                    id="telefoonnummerOndertekenaar"
                                    label="Telefoonnummer"
    >
    </snelstart-ui-text-form-control>
  </form>
}



